// extracted by mini-css-extract-plugin
export default {"container":"ExternalReviewerView_container__BHsqn","messageAndVote":"ExternalReviewerView_messageAndVote__C4DrF","votingDiv":"ExternalReviewerView_votingDiv__a5GzX"};